import React, { useState, useEffect } from 'react';
import {
	ChatContainer,
	ModalOverlay,
	ChatLayout,
} from './styles';
import { pipego } from 'api/pipego';
import { socketEvents } from 'lib/socket';
import { useWhatsappChatStore } from 'store/whatsappChat/useWhatsappChatStore';
import { ChatList } from './components/ChatList';
import { ChatArea } from './components/ChatArea';
import { Settings } from './components/Settings';
import { Sidebar } from './components/Sidebar';
import { ModalStatusSession } from './components/ModalStatusSession';
import { useForm } from 'react-hook-form';
import { useMessage } from './context/MessageContext';
import useWebSocket from './context/useWebSocket.hook';
import { useSelector } from 'react-redux';

const ChatWhatsappContent = () => {
	const { whatsappChat } = useWhatsappChatStore( ( state ) => state.states );
	const form = useForm();
	const userEmail = useSelector( state => state.auth.userLogin );
	const {
		checkWhatsAppStatus,
		setQrCode,
		handleChatClick,
		totalUnread,
		totalUnreadPendingChat,
		connectionStatus,
		qrCode,
		activeTab,
		setActiveTab,
		setConnectionStatus,
		selectedChat,
		conversations,
		onReceivedMessage,
		loadChats
	} = useMessage();
	useWebSocket( onReceivedMessage, selectedChat );

	const isOpen = whatsappChat.isOpen;
	const [ showUnreadOnly, setShowUnreadOnly ] = useState( false );
	const [ searchQuery, setSearchQuery ] = useState( '' );

	useEffect( () => {
		const checkStatusAndLoadChats = async () => {
			const isAuthenticated = checkWhatsAppStatus();
			if ( isAuthenticated ) {
				loadChats();
			}
		};
		checkStatusAndLoadChats();
		socketEvents.onQRCode( ( qrData ) => {
			console.log( 'Novo QR Code recebido via socket:', qrData?.data?.data?.qr );
			setQrCode( qrData?.data?.data?.qr || null );
		} );

		 socketEvents.onAuthenticated( ( status ) => {
			if ( status === 'connected' ) {
				setConnectionStatus( prev => ( {
					...prev,
					isAuthenticated: true
				} ) );
				setQrCode( null );
			}

			if ( status === 'wait_for_qrcode_auth' ) {
				setConnectionStatus( prev => ( {
					...prev,
					isAuthenticated: false
				} ) );		 
			}
		} );

		// const unsubscribeAuthFailure = socketEvents.onAuthFailure( () => {
		// 	console.log( 'Falha na autenticação do WhatsApp' );
		// 	setConnectionStatus( prev => ( {
		// 		...prev,
		// 		isAuthenticated: false
		// 	} ) );
		// 	checkWhatsAppStatus();
		// } );

		return () => {
			// unsubscribeAuthFailure();
		};
	}, [] );

	// useEffect( () => {
	// 	//Event - receber QR Code
	// 	console.log( 'useEffect.onQRCode: ', connectionStatus );
	// 	socketEvents.onQRCode( ( qrData ) => {
	// 		setQrCode( qrData.data.data.qr || null );
	// 	} );

	// }, [ connectionStatus ] );

	if ( !isOpen ) return null;

	if ( !connectionStatus.isAuthenticated ) {
		return (
			<ModalStatusSession
				connectionStatus={connectionStatus}
				qrCode={qrCode}
				activeTab={activeTab}
				setActiveTab={setActiveTab}
				handleUpdateSession={checkWhatsAppStatus}
			/>
		);
	}

	return (
		<ModalOverlay>
			<ChatContainer>
				<ChatLayout>
					<Sidebar
						totalUnread={totalUnread}
						totalUnreadPendingChat={totalUnreadPendingChat}
						activeTab={activeTab}
						setActiveTab={setActiveTab}
					/>
					{activeTab === 'settings' && (
						<Settings
							onBack={() => setActiveTab( 'chats' )}
							onLogout={async () => {
								try {
									await pipego.logoutWhatsApp();
									checkWhatsAppStatus();
								} catch ( error ) {
									console.error( 'Error logging out:', error );
								}
							}}
							qrCode={qrCode}
							isAuthenticated={connectionStatus.isAuthenticated}
							isLoading={!connectionStatus.hasQR && !connectionStatus.isAuthenticated}
						/>
					)}
					{activeTab === 'chats' && (
						<div style={{ 
							display  : 'flex', 
							width    : '100%', 
							height   : '100%',
							position : 'relative',
							flex     : '1 1 auto'
						}}>
							<div style={{
								width      : '35%',
								height     : '100%',
								position   : 'relative',
								flexShrink : 0
							}}>
								<ChatList
									conversations={conversations.filter( conversation => 
										conversation?.userId && 
										conversation?.userEmail === userEmail
									)}
									searchQuery={searchQuery}
									showUnreadOnly={showUnreadOnly}
									setShowUnreadOnly={setShowUnreadOnly}
									setSearchQuery={setSearchQuery}
									handleChatClick={handleChatClick}
									totalUnread={totalUnread}
									selectedConversation={selectedChat}
									activeTab={activeTab}
								/>
							</div>
							<div style={{
								width      : '65%',
								height     : '100%',
								position   : 'relative',
								flexShrink : 0
							}}>
								{selectedChat ? (
									<ChatArea
										useForm={form}
									/>
								) : (
									<div style={{
										display         : 'flex',
										alignItems      : 'center',
										justifyContent  : 'center',
										height          : '100%',
										backgroundColor : '#f0f2f5',
										color           : '#667781'
									}}>
										Selecione um chat para começar
									</div>
								)}
							</div>
						</div>
					)}
					{activeTab === 'pending' && (
						<div style={{ 
							display  : 'flex', 
							width    : '100%', 
							height   : '100%',
							position : 'relative',
							flex     : '1 1 auto'
						}}>
							<div style={{
								width      : '35%',
								height     : '100%',
								position   : 'relative',
								flexShrink : 0
							}}>
								<ChatList
									conversations={conversations
										.filter( conversation => !conversation?.userId )
										.sort( ( a, b ) => {
											const dateA = new Date( a?.createdAt || 0 );
											const dateB = new Date( b?.createdAt || 0 );
											return dateB - dateA;
										} )}
									searchQuery={searchQuery}
									showUnreadOnly={showUnreadOnly}
									setShowUnreadOnly={setShowUnreadOnly}
									setSearchQuery={setSearchQuery}
									handleChatClick={handleChatClick}
									selectedConversation={selectedChat}
									activeTab={activeTab}
								/>
							</div>
							<div style={{
								width      : '65%',
								height     : '100%',
								position   : 'relative',
								flexShrink : 0
							}}>
								{selectedChat ? (
									<ChatArea
										useForm={form}
									/>
								) : (
									<div style={{
										display         : 'flex',
										alignItems      : 'center',
										justifyContent  : 'center',
										height          : '100%',
										backgroundColor : '#f0f2f5',
										color           : '#667781'
									}}>
										Selecione um chat para começar
									</div>
								)}
							</div>
						</div>
					)}
				</ChatLayout>
			</ChatContainer>
		</ModalOverlay>
	);
};

const ChatWhatsapp = () => {
	return (
		<ChatWhatsappContent />
	);
};

export { ChatWhatsapp };
